import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { KEYS } from '../../../utils/constants';
import './Overlay.scss';

class Overlay extends Component {
  static propTypes = {
    children: PropTypes
      .oneOfType([
        PropTypes
          .arrayOf(PropTypes.element)
          .isRequired,
        PropTypes.element,
      ])
      .isRequired,
    visible: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
    onKeyDown: PropTypes.func,
  };
  static defaultProps = {
    visible: false,
    className: '',
    onClick: () => {},
    onKeyDown: () => {},
  };
  constructor() {
    super();
    this.overlayRef = React.createRef();
  }


  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      this.overlayRef.focus();
    } else {
      this.overlayRef.blur();
    }
  }
  onKeyDownHandler = (e) => {
    if (e.keyCode === KEYS.ESC) {
      this.props.onKeyDown();
    }
  }
  render() {
    const {
      children, visible, className, onClick,
    } = this.props;
    const overlayClassNames = classNames({ 'main-overlay': true, 'show-overlay': visible, [className]: true });
    return (
      <div

        className={overlayClassNames}

      >
        <div
          role="button"
          tabIndex={-2}
          onKeyDown={this.onKeyDownHandler}
          onClick={onClick}
          ref={(ref) => { this.overlayRef = ref; }}
          className="overlay-click-area"
        />

        <div className="overlay-content">
          {children}
        </div>

      </div>
    );
  }
}

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/_atomic/Overlay/Overlay.js